import {Button, ButtonProps, Text} from '@mantine/core';
import {modals} from '@mantine/modals';
import {AiOutlineReload} from 'react-icons/ai';

import {useReprovisionPipelineMutation} from '../hooks/usePipelinesQuery';
import {Pipeline} from '../types';


const REPROVISIONABLE_STATUSES = ['FAILED', 'ACTIVE'];

interface ReprovisionRecordButtonProps extends ButtonProps {
    pipeline: Pipeline;
}

export const ReprovisionRecordButton = ({pipeline, ...props}: ReprovisionRecordButtonProps) => {

    const reprovisionPipelineMutation = useReprovisionPipelineMutation();

    const disabled = !pipeline.pipelineStatus
        || !REPROVISIONABLE_STATUSES.includes(pipeline.pipelineStatus);

    const handleReprovision = async () => {
        await reprovisionPipelineMutation.mutateAsync(pipeline.id);
    };

    const openConfirmModal = () =>
        modals.openConfirmModal({
                                    title: 'Reprovision pipeline',
                                    children: (
                                        <Text size='sm'>
                                            This re-deploys the underlying CloudFormation stack for
                                            &quot;{pipeline.name ?? pipeline.id}&quot;. Are you sure you want to
                                            reprovision it?
                                        </Text>
                                    ),
                                    labels: {
                                        confirm: 'Reprovision',
                                        cancel: 'Cancel'
                                    },
                                    confirmProps: {color: 'red'},
                                    onConfirm: () => {
                                        void handleReprovision();
                                    },
                                });

    return (
        <Button
            disabled={disabled}
            onClick={openConfirmModal}
            loading={reprovisionPipelineMutation.isPending}
            leftSection={<AiOutlineReload/>}
            {...props}
        >
            Reprovision
        </Button>
    );

};
